<homey-page-title title="This page is under construction"/>
<p class="mb-6">Check back in later</p>
<p-button styleClass="w-full" (onClick)="onClick()" label="Back"/>
